import { render, staticRenderFns } from "./upPayPwd.vue?vue&type=template&id=c7e52bd2&scoped=true"
import script from "./upPayPwd.vue?vue&type=script&lang=js"
export * from "./upPayPwd.vue?vue&type=script&lang=js"
import style0 from "./upPayPwd.vue?vue&type=style&index=0&id=c7e52bd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e52bd2",
  null
  
)

export default component.exports